import { DatePipe } from '@angular/common';
import {Component, Input} from '@angular/core';
import { ToastService } from '../../../services/toast.service';
import { Instancia } from '../../../types/Instancia.type';
import { Parcela } from '../../../types/Parcela.type';
import {ContratoService} from "../../../services/contrato.service";

@Component({
  selector: 'app-processamentocontrato',
  templateUrl: './processamentocontrato.component.html',
  styleUrl: './processamentocontrato.component.css',
  providers: [DatePipe]
})
export class ProcessamentocontratoComponent {
  @Input() statusParcela: string = '';
  rangeDates!: string;
  totalRecords: number = 0;
  loading: boolean = false;
  loadingSincronizar: boolean = false;
  termo: string = "";
  instancias: Instancia[] = [
    { id: 'VALE', nome: 'VALE' },
    { id: 'UCP', nome: 'UCP' },
    { id: 'UVP', nome: 'UVP' },
  ];
  instanciaSelecionada!: string;
  parcelas: Parcela[] = []
  dataInicio!: string
  dataFim!: string
  contrato!: string
  parcelasSelecionadas: Parcela[] = []

  constructor(private contratoService: ContratoService, private toastService: ToastService, private datePipe: DatePipe){}

  onDateChange(event: any){
    this.dataInicio = this.getDataPipeTransForm(this.rangeDates[0]);
    this.dataFim = this.getDataPipeTransForm(this.rangeDates[1]);

    this.onInstanciaChange(event);
  }


  onInstanciaChange(event: any){


    if(this.instanciaSelecionada != undefined && this.dataInicio != undefined && this.dataFim != undefined){

      this.loading = true;

    this.contratoService.getParcelasPagamento(this.instanciaSelecionada, this.dataInicio, this.dataFim, this.statusParcela).subscribe({
        next: (data) => {
          this.parcelas = data
          this.totalRecords = data.length
        },
        complete: () => {
          this.loading = false;
          this.loadingSincronizar = false

          this.parcelasSelecionadas = []
        }
      })
    }else{
      this.loading = false;
      this.loadingSincronizar = false
    }
  }

  getDataPipeTransForm(data: string): string | "" {
    return this.datePipe.transform( data,'dd/MM/yyyy') || "";
  }

totalValor(parcela: Parcela): number { return parcela.taxas.reduce((sum, item) => sum + item.vlDesconto, 0); }

requisitaIntegracao(){

  this.loadingSincronizar = true;

  this.contratoService.getBuscaPagamentos(this.instanciaSelecionada, this.dataInicio, this.dataFim, this.contrato).subscribe({
    next: (data) => {
      this.toastService.info("Sucesso", "Dados carregados com sucesso");
    },
    error: (error) => {
      this.toastService.erro("Erro", "Erro: " + error.error.message);
    },
    complete: () => {

      this.onInstanciaChange({});


      this.loading = false;
      this.loadingSincronizar = false
    }
  })

}

enviarERP(){

  this.loading = true;
  this.loadingSincronizar = true;

  let corpo = {
    contratos: this.parcelasSelecionadas.map(p => { return {instancia: p.instancia, contrato: p.idContrato}}),
    dataInicio: this.dataInicio,
    dataFim: this.dataFim,
    usuario: localStorage.getItem("cdUsuarioErp")
  }

  this.contratoService.postEnviarPagamentos(corpo).subscribe({
    next: (value) => {
        this.toastService.alerta("Finalizado", "Processo finalizado")
    },
    error: (erro) => {
      this.toastService.erro("Erro", "Erro: " + erro.error.message);
    },
    complete: () => {
      this.loading = false;
      this.loadingSincronizar = false
    }
  })
}

exportar(){

  if(this.parcelasSelecionadas.length == 0){
    this.toastService.info("","Necessário selecionar os registros à serem exportados")

  }else{
    let corpo = {
      contratos: this.parcelasSelecionadas.map(p => { return {instancia: p.instancia, contrato: p.idContrato, parcela: p.idParcela}}),
      usuario: localStorage.getItem("cdUsuarioErp")
    }

    this.contratoService.exportarContratosParcelas(corpo).subscribe(blob => {
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a')
      a.href = url
      a.download = 'data.xlsx'
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    })
  }
}

}
